import { createFileRoute } from "@tanstack/react-router";
import IntegrationsHub from "@/components/views/IntegrationsHub";

export const Route = createFileRoute("/hub")({
  component: IntegrationsHub,
});
